import { createContext, useContext } from "react";
import {
  GroopitFilterDisplayDTO,
  NamedGroopitFilterDisplayDTO,
} from "groopit-js/client";
import { GroopitFilter } from "../GroopitFilterDTO";

export type FilterModes = "edit" | "saved";

export interface FilterState {
  filter: GroopitFilter;
  lastUsedFilter?: GroopitFilterDisplayDTO;
  filterMode: FilterModes;
  savedFilters: NamedGroopitFilterDisplayDTO[] | undefined;
}

export const FilterContext = createContext<FilterState | undefined>(undefined);

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw "useFilterContext() invoked without a parent provider";
  }
  return context;
};
